'use client'

import { useQuery } from '@tanstack/react-query'

import { useAuthInfo } from '@sweetauth/core'

import { fetchAgency } from '@/context/usaspending'

import type { AgencyProfile } from '@/types/usaspending'

import { usaspendingKeys } from './queryKeys'
import { assertToken } from './utils'

/**
 * Hook to fetch agency profile details
 *
 * @param id - The agency ID (agency code)
 * @param options.enabled - Whether to enable the query (default: true)
 */
export function useAgency(id: string, options: { enabled?: boolean } = {}) {
  const { enabled = true } = options
  const { accessToken } = useAuthInfo()

  return useQuery<AgencyProfile>({
    queryKey: usaspendingKeys.agencyDetail(id),
    queryFn: () => fetchAgency(assertToken(accessToken), id),
    enabled: enabled && !!id && !!accessToken,
    staleTime: 5 * 60 * 1000, // 5 minutes
  })
}
